import React from "react"
import { renderToStaticMarkup } from "react-dom/server"
import Renderer from "../renderers/renderer"
import Button from "../../add-button"
import Icon from "@kit/design/icon"

export class ActionRenderer extends Renderer {
  get buttons() {
    if (
      this.node.dataset.type === "exit-automation" ||
      this.node.dataset.type === "cancel-subscriber"
    ) {
      return []
    }

    const button = new Button()
    button.dataset.type = "child"
    button.dataset.sources = this.node.dataset.oid

    return [button]
  }

  get text() {
    return (
      renderToStaticMarkup(
        this.node.warning && (
          <Icon
            name="information-circle"
            className="text-yellow-500 absolute"
            style={{ left: "-1.2rem" }}
          />
        )
      ) + this.labelText
    )
  }

  get tooltipText() {
    if (this.node.disabled) {
      return ""
    } else if (this.node.dataset.type.includes("add-sequence")) {
      return `Add the subscriber to the <b>${this.text}</b> email sequence`
    } else if (this.node.dataset.type.includes("add-tag")) {
      return `Tag the subscriber with <b>${this.text}</b>`
    } else if (this.node.dataset.type.includes("remove-tag")) {
      return `Remove tag <b>${this.text}</b> from subscriber`
    } else if (this.node.dataset.type.includes("add-delay")) {
      return `Delay the next step for <b>${this.text}</b>`
    } else if (this.node.dataset.type.includes("delay-custom-field")) {
      return `Delay the next step until <b>Date in Custom Field</b>`
    } else if (this.node.dataset.type.includes("exit-automation")) {
      return "Remove subscriber from this automation"
    } else if (this.node.dataset.type.includes("add-automation")) {
      return `Add to ${this.text} automation`
    } else if (this.node.dataset.type.includes("cancel-subscriber")) {
      return `Unsubscribe the subscriber from your account`
    } else if (
      this.node.dataset.type === "app-action" &&
      this.detail.app_removed
    ) {
      return "This app has been uninstalled or removed. This node will no longer function as expected."
    } else {
      return ""
    }
  }

  get labelTooltipText() {
    if (this.node.warning) {
      return "Your Visual Automation will not send to any subscribers because your sequence is inactive. Select an active sequence."
    } else {
      return ""
    }
  }

  get labelText() {
    if (this.node.dataset.type.includes("exit-other-automation")) {
      return `Remove from automation <span>${this.node.dataset.name}</span>`
    } else {
      return this.node.dataset.name
    }
  }
}
